module.exports = __webpack_public_path__ + "img/up-arrow.d9735b7d.svg";